// The Send warnings, all in one dialog (2026-10-30, docs/contact-view.md
// "What can stop Send"; sendWarnings.js). The same MUI Dialog look as the
// shared ConfirmDialog.jsx, which holds one sentence; this one holds a list.
// Each warning is in plain words with its fixes beside it (Process the step,
// Mark this step not needed, Choose the path, Add the attachment ...). Cancel
// is the default (focused; Escape or a click outside). "Send anyway" sends
// the reply exactly as written; once a fix has settled every warning it reads
// "Send".
//
// warnings: [{ code, text, fixes? }]; onFix(fix, warning): the panel runs it;
// onSendAnyway(): sends with the warnings' codes acknowledged.
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'

export default function SendWarningsDialog({ open, warnings = [], onCancel, onSendAnyway, onFix, testId = 'send-warnings' }) {
  const list = warnings ?? []
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth data-testid={testId} aria-labelledby={`${testId}-title`}>
      <DialogTitle id={`${testId}-title`}>{list.length ? 'Before you send' : 'Ready to send'}</DialogTitle>
      <DialogContent>
        {list.length ? (
          <Stack spacing={1}>
            {list.map((w, i) => (
              <Alert key={`${w.code}-${w.kind ?? ''}-${w.index ?? i}`} severity="warning" data-testid="send-warning" data-code={w.code}>
                <Typography variant="body2">{w.text}</Typography>
                {(w.fixes ?? []).length > 0 && (
                  <Stack direction="row" spacing={1} sx={{ mt: 0.75, flexWrap: 'wrap' }}>
                    {w.fixes.map((f) => (
                      <Button key={`${f.kind}-${f.index ?? ''}`} size="small" variant="outlined" color="inherit" onClick={() => onFix?.(f, w)} data-testid={`send-warning-fix-${f.kind}`}>
                        {f.label}
                      </Button>
                    ))}
                  </Stack>
                )}
              </Alert>
            ))}
          </Stack>
        ) : (
          <Typography>Nothing left to warn about.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus data-testid={`${testId}-cancel`}>Cancel</Button>
        <Button variant="contained" color={list.length ? 'warning' : 'success'} onClick={onSendAnyway} data-testid={`${testId}-send-anyway`}>
          {list.length ? 'Send anyway' : 'Send'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
